import type {
  Response,
  ChasedApplicantResponse,
} from '@/lib/apollo/query/getChasedApplicants/query'

import type { TransformedChasedApplicantData, TransformedData } from './types'

export const toTransformedChasedApplicantData = (
  chasedApplicant: ChasedApplicantResponse,
): TransformedChasedApplicantData => ({
  ...chasedApplicant,
})

export const toTransformedData = (response?: Response): TransformedData | undefined =>
  response === undefined
    ? undefined
    : {
        ...response.getChasedApplicants,
        results: response.getChasedApplicants.results.map(
          toTransformedChasedApplicantData,
        ),
      }
